// extracted by mini-css-extract-plugin
export default {"cls1":"Banner-cls1__ae95f7e7513dba1705de","cls2":"Banner-cls2___4b78af3c4f04446e068 Banner-cls1__ae95f7e7513dba1705de"};